import React, { useState, useEffect } from "react";

export default function useTimer(duration) {
  const [timer, setTimer] = useState(duration);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let intervalId = null;

    if (isRunning && timer > 0) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    if (timer === 0) {
      setTimer(duration);
      stopTimer();
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [timer, isRunning]);

  const startTimer = () => {
    setIsRunning(true);
  };

  const stopTimer = () => {
    setIsRunning(false);
  };

  const resetTimer = () => {
    setTimer(duration);
    setIsRunning(false);
  };

  return {
    timer,
    isRunning,
    startTimer,
    stopTimer,
    resetTimer,
  };
}
